import React, { useEffect, useState } from "react";
import Select from "react-select";
import {GENERIC_PAGINATED_KEY_VALUE_LIST, getApiPath} from "../../../api/ApiConst";
import apiCaller from "../../../api/ApiCaller";

const CollectionObjectDropdown = ({ field = [], name, value, onChange }) => {
  const [optionList, setOptionList] = useState([]);
  const selectedOption = optionList.find((option) => option.value === value);

  useEffect(() => {
    const keyAttribute = field?.keyValuePair?.keyAttribute;
    const valueAttribute = field?.keyValuePair?.valueAttribute;
    if (!keyAttribute || !valueAttribute) return;

    const tableUrl = getApiPath(field?.referenceTablePath, GENERIC_PAGINATED_KEY_VALUE_LIST);
    const payload = {
      page: 0,
      size: 200,
      searchFilters: [],
      sortRules: [],
      keyAttribute,
      valueAttribute,
    };

    if(field?.referenceTablePath === "null" || field?.referenceTablePath === "undefined"){
      return;
    }

    apiCaller.callPostApi(
      tableUrl,
      payload,
      {},
      (response) => {
        const data = response?.data;
        setOptionList(
          Array.isArray(data)
            ? data.map((pair) => ({ label: pair.value, value: pair.key }))
            : []
        );
      },
      (error) => {
        console.error("error");
      }
    );
  }, []);

  return (
    <>
      <Select
        name={name}
        value={{ label: selectedOption?.label, value }}
        options={optionList}
        onChange={(event) =>
          onChange({
            target: { name, value: event.value },
          })
        }
        className="react-select-container"
      />
    </>
  );
};

export default CollectionObjectDropdown;
